import React, { useState, useEffect } from "react";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import swal from "@sweetalert/with-react";
import numberToComma from "../../utils/numberToComma";
import cart from "../../images/cart.png";
import truncate from "../../utils/truncate";

import "./styles.scss";
import Layout from "../../components/Layout/Layout";
import CardTiny from "../../components/CardTiny/CardTiny";

import { Card, Col, Row } from "reactstrap";
import { Link, useHistory } from "react-router-dom";

import ImageGallery from "react-image-gallery";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  fetchSingleProduct,
  fetchAddCart,
  fetchFavoritePost,
  fetchCancelOrder,
  fetchReviews,
  fetchFavoriteRemove,
} from "../../redux/actions/products";

const Product = (props) => {
  const {
    match: { params },
  } = props;
  const [count, setCount] = useState(1);
  const [selected, setSelected] = useState("");
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(2);
  const style = "product-infos";
  const [product, setProduct] = useState({ product: {} });
  const [store, setStore] = useState({ store: {} });
  const [related, setRelated] = useState({});
  const [variation, setVariation] = useState({ variation: [] });
  const [img, setImg] = useState({ img: [] });
  const [message, setMessage] = useState("");
  const [check, setCheck] = useState(false);
  const [activeVaria, setActiveVaria] = useState({});
  const [reviews, setReview] = useState([]);

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };
  const up = (i) => {
    setCount(count + 1);
  };
  const down = (i) => {
    if (count > 1) setCount(count - 1);
  };

  const addToCart = () => {
    const data = {
      quantity: count,
      product_id: product.product.id,
      variation_id: activeVaria?.id !== undefined ? activeVaria.id : null,
    };
    props.fetchAddCart(data);
    setCheck(true);
  };

  const saveItem = (id) => {
    props.fetchFavoritePost(id);
    setCheck(true);
  };

  function removeFav(id) {
    props.fetchFavoriteRemove(id);
    setCheck(true);
  }

  const selectVariation = (item) => {
    setActiveVaria(item);
    setSelected(item.id);
  };

  useEffect(() => {
    setCount(count);
    props.fetchSingleProduct(params.item);
    props.fetchReviews(params.item);
  }, []);

  useEffect(() => {
    setCount(count);
    props.fetchSingleProduct(params.item);
    props.fetchReviews(params.item);
  }, [params.item]);

  useEffect(() => {
    if (check) {
      if (props.carts.carts.data) {
        // swal(popUpCart);
        swal(popUpCart, {
          buttons: {
            checkout: {
              text: "proceed to checkout",
              className: "proceed-btn",
            },
            continue: {
              text: "continue shopping",
              className: "continue-btn",
            },
            cancel: false,
          },
        }).then((value) => {
          switch (value) {
            case "checkout":
              history.push("/cart");
              break;
            case "continue":
              setCheck(true);
              // swal("cancel orders", "success");
              break;
            default:
          }
        });
      }
      //swal(popUpCart);
      setMessage(props.cart.cart.message);
      NotificationManager.success(props.cart.cart.message);
      setCheck(false);
    }
  }, [props.cart.cart]);

  useEffect(() => {
    if (check && props.cart.errors.errors.code !== 412) {
      setMessage(props.cart.errors.errors);
      //NotificationManager.error(props.cart.errors.errors.message);
      swal({
        //title: "Are you sure?",
        title: props.cart.errors.errors.message,
        icon: "warning",
        buttons: {
          orders: "go to orders",
          cancelOrder: "cancel orders",
          cancel: true,
        },
      }).then((value) => {
        switch (value) {
          case "orders":
            history.push("/product-checkout");
            break;
          case "cancelOrder":
            props.fetchCancelOrder();
            setCheck(true);
            // swal("cancel orders", "success");
            break;
          default:
        }
      });
      setCheck(false);
    }
    if (check && props.cart.errors.errors.code === 412) {
      swal("Session timed out", "Please login to continue", "error");
      setCheck(false);
    }

    if (check && props.cart.errors.errors.code === 400) {
      swal(props.cart.errors.errors.message, "", "error");
      setCheck(false);
    }
  }, [props.cart.errors.errors]);

  useEffect(() => {
    if (check) {
      swal("You have no pending orders", "", "success");
    }
    setCheck(false);
  }, [props.order.order.data]);

  useEffect(() => {
    if (props.product.product.data) {
      setProduct({ ...product, product: props.product.product.data.product });
      setStore({ ...store, store: props.product.product.data.store });
      setRelated(props.product.product.data.related);
      setVariation({
        ...variation,
        variation: props.product.product.data.product.product_variations,
      });
      setActiveVaria(props.product.product.data.product?.product_variations[0]);
      if (props.product.product.data.product.images) {
        setImg({ ...img, img: props.product.product.data.product.images });
      }
    }
  }, [props.product]);

  useEffect(() => {
    if (check) {
      // setMessage(props.favorites.favorites.message);
      // NotificationManager.success(props.favorites.favorites.message);

      props.fetchSingleProduct(params.item);
      NotificationManager.success(props.favorites.favorites.message);
      setCheck(false);
    }
  }, [props.favorites.favorites]);

  useEffect(() => {
    if (props.reviews.reviews.data) {
      setReview(props.reviews.reviews.data.reviews);
    }
  }, [props.reviews.reviews]);

  const popUpCart = (
    <div>
      <h4 className="text-left">1 Item added</h4>
      <hr />
      <div className="d-flex justify-content-around">
        <img src={img.img[0]} alt="..." width="30%" />
        <h6> {product.product.product_name}</h6>
      </div>
      <table className="table table-borderless">
        <tbody>
          <tr>
            <td className="text-left">Total :</td>
            <td className="text-right">
              ₦
              {numberToComma(
                activeVaria?.net_price !== undefined
                  ? activeVaria.net_price
                  : product.product.net_price
                  ? product.product.net_price
                  : "no price"
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

  const prod_image = img.img.map((index, i) => {
    const imaged = {
      original: index,
      thumbnail: index,
      //sizes:'100vw'
    };
    return imaged;
  });

  return (
    <Layout>
      <section className="product-container">
        <div className="bread-crumbs mb-4">
          <Link to="/">Home</Link> <i class="fa fa-caret-right pl-2 pr-2"></i>
          <Link to={`/product-category/${product.product.categoty_id}`}>
            {product.product.category_title}
          </Link>
          <i class="fa fa-caret-right pl-2 pr-2"></i>
          <Link to={`/product/${product.product.product_slug}`}>
            {product.product.product_name}
          </Link>
        </div>
        <NotificationContainer />
        <Row>
          <Col sm={12} md={3} lg={3} className="">
            <Card className="product-card">
              <div className="product-card-body">
                <div className="image-view">
                  <ImageGallery
                    items={prod_image}
                    showPlayButton={false}
                    onErrorImageURL={cart}
                  />
                </div>
              </div>
            </Card>
            <Card className="product-card related-items">
              <div className="product-card-body">
                <strong>related items</strong>
                <div className="row text-center">
                  {(related.products || []).map((item, i) => {
                    return (
                      <CardTiny
                        photo={item.images[0]}
                        item={item.product_name}
                        price={item.net_price}
                        action={() => history.push(`/product/${item.product_slug}`)}
                      />
                    );
                  })}
                </div>
              </div>
            </Card>
          </Col>

          <Col sm={12} md={6} lg={6} className="">
            <Card className="product-card">
              <div className="product-card-body">
                <div>
                  {(activeVaria?.quantity === undefined
                    ? product.product.stock_limit < 1
                    : activeVaria?.quantity < 1) && (
                    <h5 className="text-danger">OUT OF STOCK</h5>
                  )}
                  <div className="d-flex justify-content-between">
                    <div>
                      <h2>{product.product.product_name}</h2>
                      <p>
                        {truncate(
                          product.product.description === undefined
                            ? " "
                            : product.product.description,
                          200
                        )}
                      </p>
                    </div>

                    <div className="d-flex justify-content-between product-container-heart">
                      <span
                        className="product-heart-container"
                        onClick={() => {
                          if (product.product.favourites.length > 0) {
                            removeFav(product.product.id);
                          } else {
                            saveItem(product.product.id);
                          }
                        }}
                      >
                        {product.product.favourites ? (
                          product.product.favourites.length > 0 ? (
                            <span style={{ color: "#0279B8" }}>
                              <i className="fa fa-heart" aria-hidden="true"></i>
                            </span>
                          ) : (
                            <i class="fa fa-heart-o" aria-hidden="true"></i>
                          )
                        ) : (
                          <i class="fa fa-heart-o" aria-hidden="true"></i>
                        )}
                      </span>
                      <span className="product-heart-container">
                        <i class="fa fa-share-square-o" aria-hidden="true"></i>
                      </span>
                    </div>
                  </div>
                  <h2>
                    ₦{" "}
                    {numberToComma(
                      activeVaria?.net_price !== undefined
                        ? activeVaria.net_price
                        : product.product.net_price
                        ? product.product.net_price
                        : "no price"
                    )}
                  </h2>
                  <div className="d-flex justify-content-between">
                    <p>
                      <span className="text-primary text-small">
                        -
                        {
                          (activeVaria?.discount_type !== undefined && activeVaria?.discount_type === 'value')
                          ? '₦' : product.product.discount_type === 'value'
                          ? '₦'
                          : ''
                        }
                        {activeVaria?.discount !== undefined
                          ? activeVaria.discount
                          : product.product.discount
                          ? product.product.discount
                          : "no discount"}
                       {
                          (activeVaria?.discount_type !== undefined && activeVaria?.discount_type === 'percent')
                          ? '%' : product.product.discount_type === 'percent'
                          ? '%'
                          : ''
                        }
                      </span>
                      <del>
                        ₦{" "}
                        {numberToComma(
                          activeVaria?.price !== undefined
                            ? activeVaria.price
                            : product.product.price
                            ? product.product.price
                            : "no price"
                        )}
                      </del>
                    </p>
                    <span>
                      <i class="fa fa-star" aria-hidden="true"></i>{" "}
                      {product.product.rating}
                    </span>
                  </div>
                  <hr />

                  <p>Qty</p>
                  <div>
                    <button onClick={down} className="count-cart">
                      -
                    </button>
                    <span className="count-cart-number"> {count} </span>
                    <button onClick={up} className="count-cart">
                      +
                    </button>
                  </div>
                  <button
                    onClick={addToCart}
                    className="btn-primary btn btn-block mt-4"
                    disabled={
                      (
                        activeVaria?.quantity === undefined
                          ? product.product.stock_limit < 1
                          : activeVaria?.quantity < 1
                      )
                        ? true
                        : false
                    }
                  >
                    {(
                      activeVaria?.quantity === undefined
                        ? product.product.stock_limit < 1
                        : activeVaria?.quantity < 1
                    )
                      ? "SOLD OUT"
                      : "ADD TO CART"}
                  </button>
                  <br />

                  {product.product.hasVariation && (
                    <div>
                      <p>Variation</p>
                      {(variation.variation || []).map((item, i) => {
                        return (
                          <div key={i} className="variation-cont">
                            <p
                              className={
                                activeVaria.id === item.id
                                  ? `variation-selected`
                                  : `variation-cart`
                              }
                              onClick={() => selectVariation(item)}
                            >
                              {item.variation}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </Card>

            <Card className="product-card">
              <div className="product-card-body">
                <Row className="text-center pb-3">
                  <Col xs={12} md={4}>
                    <h6
                      className={activeTab === 1 ? style : "prod"}
                      onClick={() => toggle(1)}
                    >
                      Description
                    </h6>
                  </Col>
                  <Col xs={12} md={4}>
                    <h6
                      className={activeTab === 2 ? style : "prod"}
                      onClick={() => toggle(2)}
                    >
                      Specification
                    </h6>
                  </Col>
                  <Col xs={12} md={4}>
                    <h6
                      className={activeTab === 3 ? style : "prod"}
                      onClick={() => toggle(3)}
                    >
                      Reviews
                    </h6>
                  </Col>
                </Row>

                {activeTab === 1 && (
                  <div>
                    {" "}
                    <p>{product.product.description}</p>
                  </div>
                )}
                {activeTab === 2 && <div>{product.product.specification}</div>}
                {activeTab === 3 && (
                  <div className="pt-3">
                    {(reviews || []).map((item, i) => {
                      return (
                        <div>
                          <div className="row text-left" key={i}>
                            <div className="col-md-3">
                              <p>{item.user.full_name}</p>
                            </div>
                            <div className="col-md-7">
                              <p>{item.review}</p>
                            </div>
                            <div className="col-md-2">
                              <p>
                                {item.star}{" "}
                                <i class="fa fa-star" aria-hidden="true"></i>{" "}
                              </p>
                            </div>
                          </div>
                          <hr />
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            </Card>

            <Card className="product-card">
              <div className="product-card-body">
                {(activeVaria?.quantity === undefined
                  ? product.product.stock_limit < 1
                  : activeVaria?.quantity < 1) && (
                  <h5 className="text-danger">OUT OF STOCK</h5>
                )}
                <Row>
                  <Col xs={12} sm={12} md={2} className="pl-1">
                    <img src={img.img[0]} width="100%" alt="item" />
                  </Col>
                  <Col xs={12} sm={12} md={6} className="p-2 pl-1">
                    <h4 className="mb-2">{product.product.product_name}</h4>
                    <h6>
                      ₦{" "}
                      {numberToComma(
                        product.product.price
                          ? product.product.price
                          : "no price"
                      )}
                    </h6>
                    <p>
                      <span className="text-primary text-small">
                        -{product.product.discount}%{" "}
                      </span>
                      <del>
                        ₦{" "}
                        {numberToComma(
                          product.product.net_price
                            ? product.product.net_price
                            : "no price"
                        )}
                      </del>
                    </p>
                  </Col>
                  <Col xs={12} sm={6} md={4} className="pl-1 pr-1 text-right">
                    <button className="btn btn-outline-primary bid-btn mb-2">
                      call
                    </button>
                    <button
                      className="btn btn-outline-primary btn-block bid-btn"
                      onClick={addToCart}
                      disabled={
                        (
                          activeVaria?.quantity === undefined
                            ? product.product.stock_limit < 1
                            : activeVaria?.quantity < 1
                        )
                          ? true
                          : false
                      }
                    >
                      {(
                        activeVaria?.quantity === undefined
                          ? product.product.stock_limit < 1
                          : activeVaria?.quantity < 1
                      )
                        ? "SOLD OUT"
                        : "ADD TO CART"}
                    </button>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>

          <Col sm={12} md={3} lg={3} className="pr-2">
            <Card className="product-card">
              <div className="product-card-body text-center">
                <div className="d-flex justify-content-center">
                  <img
                    className="bid-image-container"
                    src={store.store.logo}
                    alt=""
                  />
                </div>
                <h2>{store.store.store_name}</h2>
                <span>
                  <i class="fa fa-location-arrow" aria-hidden="true"></i>
                  {store.store.store_location_address}
                </span>
                <div className="d-flex justify-content-center">
                  <div className="mt-3 pr-4 bid-ads">
                    <p>{store.store.likes}</p>
                    <p>Followers</p>
                  </div>
                  <div className="ml-4 mt-3">
                    <p>{store.store.total_purchases}</p>
                    <p>Solds</p>
                  </div>
                </div>
                <div className="d-flex justify-content-center mt-3 row">
                  <button className="btn btn-outline-primary bid-btn">
                    call
                  </button>
                  <button className="btn btn-outline-primary bid-btn">
                    follow
                  </button>
                  <button
                    className="btn text-white sell"
                    onClick={() =>
                      window.open(
                        `http://${store.store.store_url}.shobbu.com`,
                        "_blank"
                      )
                    }
                  >
                    view site
                  </button>
                </div>
                {/* <span>
                  <i class="fa fa-star" aria-hidden="true"></i>{" "}
                  <i class="fa fa-star" aria-hidden="true"></i>{" "}
                  <i class="fa fa-star" aria-hidden="true"></i>{" "}
                  <i class="fa fa-star-o" aria-hidden="true"></i>{" "}
                  <i class="fa fa-star-o" aria-hidden="true"></i> 3
                </span>
                <p>rate score</p>
                <p>{store.store.description}</p> */}
              </div>
            </Card>

            <Card className="product-card related-items-mobile">
              <div className="product-card-body ">
                <strong className="pb-3">related items</strong>
                <div className="row justify-content-center">
                  {(related.products || []).map((item, i) => {
                    return (
                      <CardTiny
                        photo={item.images[0]}
                        item={item.product_name}
                        price={item.price}
                        action={() => history.push(`/product/${item.product_slug}`)}
                      />
                    );
                  })}
                </div>
              </div>
            </Card>

            <Card className="product-card">
              <div className="product-card-body text-center">
                <p>More from this seller </p>
                {/* <div>
                  <CardSmall
                    photo={photo}
                    item="freak"
                    desc="this is short"
                    price="N 23000"
                  />
                  <CardSmall
                    photo={carsell}
                    item="freak"
                    desc="this is short"
                    price="N 23000"
                  />
                </div> */}
                <Link to>125 more</Link>
              </div>
            </Card>
          </Col>
        </Row>
      </section>
    </Layout>
  );
};

Product.propTypes = {
  product: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  product: state.product,
  carts: state.carts,
  favorites: state.favorites,
  order: state.order,
  cart: state.cart,
  reviews: state.reviews,
});

const pageActions = {
  fetchSingleProduct,
  fetchAddCart,
  fetchFavoritePost,
  fetchCancelOrder,
  fetchReviews,
  fetchFavoriteRemove,
};
export default connect(mapStateToProps, pageActions)(Product);
